module.exports = __webpack_public_path__ + "../assets/dekstop-2.jpg";